// extracted by mini-css-extract-plugin
module.exports = {"heading":"Formulario_heading__moQW_","buscador":"Formulario_buscador__3RKCO","btn_block":"Formulario_btn_block__hBGWX"};